/**
 * Joins a path onto an Environment's endpoint, keeping the endpoint's own path.
 *
 * Most endpoints are an origin, but an Environment behind the Network Gateway answers under
 * `/r/<route ticket>` (ADR-0147), so a path is appended to the base rather than replacing it.
 * A query in `path` is kept; the endpoint's own query and fragment are not.
 */
export function joinEnvironmentPath(baseUrl: string, path: string): URL {
  const url = new URL(baseUrl);
  const relative = new URL(path.startsWith("/") ? path : `/${path}`, "http://relative.invalid");
  url.pathname = `${url.pathname.replace(/\/+$/, "")}${relative.pathname}`;
  url.search = relative.search;
  url.hash = "";
  return url;
}

export const environmentEndpointUrl = (httpBaseUrl: string, pathname: string): string => {
  const url = joinEnvironmentPath(httpBaseUrl, pathname);
  url.search = "";
  return url.toString();
};
